// 업체 디테일 페이지 (mockup/equipment-overview, equipment-data-report, equipment-status) 기반 임시 데이터.
// KPI 2.0 어드민 영역 + 회사 상세 본문(Overview / DataReport / EquipmentStatus) 은
// 모두 실제 API 로 교체 완료 (6-2 ~ 6-8). 현재 이 파일에 남은 mock 은
// 카테고리 추가 모달의 "대표 장비 선택" 실패 fallback 옵션 뿐이다.

// ─── Overview 탭 ─────────────────────────────────────────────────────────────
// Overview / DataReport / EquipmentStatus 탭 본문 카드·로그·메타 mock 은
// 실제 API 연동 완료로 제거됨:
//  - GET /api/admin/company/{id}/overview
//  - GET /api/admin/company/{id}/data-report/summary, .../logs
//  - GET /api/admin/company/{id}/equipment-status
//
// OverviewTab 의 알람/알림 카드 2종만 컴포넌트 내부 클라이언트 상수로 잔존 (백엔드 집계 미구현).

// ─── Category 본문 (CategoryContent — 카테고리 추가 모달 보조 옵션) ──────────
// 카테고리 추가 시 "대표 장비 선택" select 의 placeholder 옵션. 실제 회사 장비 목록은
// CategoryContent 가 adminMachineUseCase 로 별도 조회한다. 이 mock 은 디자인 표기용.

export interface CategoryTargetEquipmentOption {
  label: string;
  ip: string;
}

export const MOCK_CATEGORY_TARGET_EQUIPMENT_OPTIONS: CategoryTargetEquipmentOption[] = [
  { label: "HP Indigo 12000 · Digital Sheet-fed Press", ip: "192.168.0.21" },
  { label: "Konica Minolta AccurioPress C14000",        ip: "192.168.0.22" },
  { label: "Heidelberg POLAR 78 X",                     ip: "192.168.0.31" },
];
